import Node from './node';

export default class Video extends Node {
  clone() {
    return new Video(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
